var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlorinSign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M286.016 125.5L247.471 224H320C337.672 224 352 238.312 352 256S337.672 288 320 288H222.426L172.484 415.625C157.438 454.125 118.266 480 75.016 480H40C17.906 480 0 462.094 0 440S17.906 400 40 400H75.016C85.422 400 94.875 394.438 97.984 386.5L136.529 288H64C46.328 288 32 273.688 32 256S46.328 224 64 224H161.574L211.516 96.375C226.562 57.875 265.734 32 308.984 32H344C366.094 32 384 49.906 384 72S366.094 112 344 112H308.984C298.578 112 289.125 117.562 286.016 125.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlorinSign);
export default __webpack_public_path__ + "static/media/florin-sign.678d61105deab5ac80d3463a733616a9.svg";
export { ForwardRef as ReactComponent };